export default {
  admissions: state => state.admissions,
}
